import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    fullscreenActionDialog: {
        position: 'fixed',
        top: 0,
        right: 0,
        left: 0,
        width: '100%',
        minWidth: '100%',
        height: '100%',
        overflow: 'auto',
        padding: {
            xs: '7rem 1rem 7rem',
            md: '7rem',
        },
        zIndex: 900,
        background: defaultPalette.lightGrey.main,
    },
    fullScreenActionDialogMainContainer: {
        width: '100%',
    },
    fullScreenActionDialogInnerContainer: {
        width: '100%',
        padding: '1.5rem',
        borderRadius: '1rem',
        backgroundColor: defaultPalette.white.main,
        boxShadow:
            '0px 10px 13px -6px rgba(193, 193, 194, 0.20), 0px 2px 40px 7px rgba(239, 241, 243, 0.25), 0px 8px 33px 3px rgba(183, 186, 194, 0.30)',
    },
})
